import styled, { css } from 'styled-components'
import Flex from 'components/priority/Flex/Flex'
import Icon from 'components/priority/Icon/Icon'
import colors from 'utils/styling/colors'

export const IconWrapper = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 100%;
  display: none;
  position: absolute;
  top: -12px;
  right: -12px;
  background: ${colors('white')};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
`

export const ImageItem = styled(Flex)`
  &:hover {
    background: ${colors('gray5')};

    ${IconWrapper} {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
`

export const Image = styled(Flex)(
  ({ src, srcPrefix, backgroundColor }) => css`
    /* prettier-ignore */
    background: url("${srcPrefix || ''}${src}") center/contain no-repeat;
    background-color: ${backgroundColor};
  `,
)

export const Page = styled(Flex)(
  () => css`
    border: 1px solid ${colors('gray1')};
    border-radius: 2px;
    height: 50px;
    width: 375px;
  `,
)

export const ProductWrapper = styled.div`
  transform: translate(-50%, -50%) scale(0.1);
  max-width: 150px;
  max-height: 75px;
  position: relative;
`

export const DragIcon = styled(Icon)(
  ({ isDragged, isSelected, disabled }) => css`
    cursor: ${disabled
      ? 'not-allowed'
      : isSelected || isDragged
        ? 'grabbing'
        : 'grab'};
    opacity: ${disabled ? 0.35 : 1};
  `,
)
